import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule, provideNativeDateAdapter} from '@angular/material/core';
import {MatIconModule} from '@angular/material/icon';

export type FilterFieldType = 'text' | 'select' | 'date';
export interface FilterField {
  key: string;
  type: FilterFieldType;
  label: string;
  options?: { value: any; label: string }[];
}

@Component({
  selector: 'app-filter-bar',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule, MatInputModule, MatSelectModule,
    MatDatepickerModule, MatNativeDateModule,
    MatIconModule
  ],
  providers: [
      provideNativeDateAdapter()
  ],
  templateUrl: './filter-bar.component.html',
  styleUrls: ['./filter-bar.component.scss']
})
export class FilterBarComponent implements OnChanges {
  @Input() fields: FilterField[] = [];
  @Input() initialValues: Record<string, any> = {};
  @Output() apply = new EventEmitter<Record<string, any>>();
  @Output() reset = new EventEmitter<void>();

  form: FormGroup = this.fb.group({});

  constructor(private fb: FormBuilder) {}

  ngOnChanges(ch: SimpleChanges): void {
    if (ch['fields']) {
      const group: Record<string, any> = {};
      this.fields.forEach(f => group[f.key] = [this.initialValues[f.key] ?? null]);
      this.form = this.fb.group(group);
    }
    if (ch['initialValues'] && this.form) {
      this.form.patchValue(this.initialValues, { emitEvent: false });
    }
  }

  onApply() { this.apply.emit(this.form.getRawValue()); }
  onReset() { this.form.reset(); this.reset.emit(); }
}
